var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPastClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 282,
    viewBox: "0 0 282 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 141,
    cy: 141,
    r: 141,
    fill: "#A7A6CE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.64 205.078c-4.671 4.806-8.85 7.631-12.05 9.764-31.206 20.801-66.878 14.806-77.907 12.757-17.794-3.306-32.814-5.639-45.72-17.278-29.324-26.449-27.897-81.623-5.49-115.8 2.657-4.053 25.03-37.161 60.78-41.827.874-.114 1.527-.179 2.098-.24 5.53-.584 39.801-3.669 67.745 19.703 4 3.346 10.437 9.38 16.406 18.584 21.827 33.652 21.896 85.773-5.862 114.337",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.941 71.502a.643.643 0 0 1 .052-.859 26 26 0 0 1 1.632-1.469.645.645 0 0 1 .907.085l.008.01a.64.64 0 0 1-.094.896c-.535.442-1.056.912-1.549 1.396a.645.645 0 0 1-.956-.059m4.416-3.457-.044-.063a.643.643 0 0 1 .209-.885 26 26 0 0 1 1.914-1.075.643.643 0 1 1 .583 1.147 25 25 0 0 0-1.819 1.021.645.645 0 0 1-.843-.145m5.07-2.4a.644.644 0 0 1 .295-1.01 26 26 0 0 1 2.107-.621.643.643 0 1 1 .312 1.248c-.673.167-1.346.366-2.001.59a.645.645 0 0 1-.713-.208m5.481-1.21a.643.643 0 0 1 .437-1.04 26 26 0 0 1 2.193-.135.644.644 0 1 1 .025 1.286c-.693.013-1.394.056-2.083.129a.65.65 0 0 1-.572-.24m5.613.042a.644.644 0 0 1 .581-1.04c.723.087 1.452.206 2.168.353a.643.643 0 1 1-.261 1.26c-.68-.14-1.373-.253-2.06-.335a.65.65 0 0 1-.428-.238m5.464 1.28a.643.643 0 0 1 .72-1.007c.687.244 1.372.521 2.036.823a.644.644 0 0 1-.534 1.17 25 25 0 0 0-1.934-.78.64.64 0 0 1-.288-.206m15.905 17.485a.6.6 0 0 1-.121-.244 24 24 0 0 0-.595-1.997.644.644 0 0 1 1.219-.42c.238.69.449 1.398.626 2.104a.643.643 0 0 1-1.129.557m-10.864-15.03a.644.644 0 0 1 .85-.944c.615.392 1.221.814 1.801 1.256a.644.644 0 0 1-.782 1.022c-.551-.42-1.126-.82-1.71-1.191a.6.6 0 0 1-.159-.142m8.893 9.784a.6.6 0 0 1-.071-.109 25 25 0 0 0-1.026-1.814.645.645 0 0 1 1.094-.68 26 26 0 0 1 1.08 1.91.644.644 0 0 1-1.077.694m-4.528-6.265a.645.645 0 0 1 .963-.852 26 26 0 0 1 1.474 1.626l.009.01a.644.644 0 0 1-.999.811 25 25 0 0 0-1.401-1.543zm7.198 15.972a.64.64 0 0 1-.139-.359 24 24 0 0 0-.085-.998.644.644 0 0 1 1.281-.136c.037.35.067.703.09 1.051a.643.643 0 0 1-1.147.442m-6.484 18.509a.64.64 0 0 1 .028-.834q.337-.369.661-.754a.646.646 0 0 1 .908-.079.64.64 0 0 1 .079.906q-.34.405-.696.794a.645.645 0 0 1-.98-.033m-38.166-1.246a28 28 0 0 1-.544-.707.643.643 0 1 1 1.035-.767c.411.553.843 1.088 1.291 1.595a.645.645 0 0 1-.968.85c-.276-.314-.55-.641-.814-.971m-2.38-3.565a1 1 0 0 1-.061-.091 26 26 0 0 1-.962-1.933.645.645 0 0 1 1.177-.523c.277.62.584 1.238.914 1.836a.645.645 0 0 1-1.068.711m5.605 6.916a.64.64 0 0 1 .016-.82.645.645 0 0 1 .909-.067c.515.445 1.056.873 1.609 1.273a.644.644 0 0 1-.757 1.041 26 26 0 0 1-1.694-1.34.6.6 0 0 1-.083-.087m-7.72-12.011a.6.6 0 0 1-.114-.222c-.2-.689-.372-1.394-.513-2.097a.644.644 0 0 1 1.264-.252c.133.667.297 1.337.487 1.991a.646.646 0 0 1-1.124.58m12.271 15.129a.643.643 0 0 1 .808-.968c.6.32 1.222.618 1.849.888a.642.642 0 1 1-.509 1.181 25 25 0 0 1-1.947-.935.6.6 0 0 1-.201-.166m5.127 2.045a.643.643 0 0 1 .675-1.021c.658.182 1.331.338 2.001.465a.642.642 0 1 1-.24 1.263 26 26 0 0 1-2.104-.488.64.64 0 0 1-.332-.219m5.451.881a.642.642 0 0 1 .537-1.043 25 25 0 0 0 2.054.019.644.644 0 1 1 .042 1.285c-.716.024-1.444.017-2.161-.019a.65.65 0 0 1-.472-.242m5.514-.327a.643.643 0 0 1 .395-1.034 25 25 0 0 0 2.008-.431.644.644 0 1 1 .324 1.244c-.694.181-1.406.333-2.114.455a.64.64 0 0 1-.613-.234m5.309-1.528a.642.642 0 0 1 .258-.995c.629-.26 1.256-.55 1.862-.862a.643.643 0 1 1 .591 1.143c-.639.329-1.298.634-1.961.907a.645.645 0 0 1-.75-.193m4.84-2.653-.024-.032a.643.643 0 0 1 .158-.896 26 26 0 0 0 1.632-1.246.645.645 0 0 1 .907.083.636.636 0 0 1-.083.906 27 27 0 0 1-1.717 1.31.644.644 0 0 1-.873-.125m-39.452-18.998a.65.65 0 0 1-.139-.362 28 28 0 0 1-.041-1.054.644.644 0 0 1 1.289-.024q.009.504.039 1.001a.644.644 0 0 1-1.148.439",
    opacity: 0.3,
    fill: "#BDD0FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.892 86.889a.3.3 0 0 0 .137.32l3.132 1.9c.028 1.709.329 3.425.918 5.082l-2.266 2.872c-.08.1-.087.24-.017.349l2.377 3.691a.3.3 0 0 0 .325.129l3.558-.866a16 16 0 0 0 4.25 2.942l.432 3.633c.015.128.11.231.235.259l4.296.931a.3.3 0 0 0 .321-.137l1.903-3.127a16 16 0 0 0 5.09-.916l2.877 2.263a.3.3 0 0 0 .35.017l3.697-2.374a.3.3 0 0 0 .13-.324l-.868-3.552a16 16 0 0 0 2.947-4.243l3.639-.431a.3.3 0 0 0 .259-.235l.934-4.288a.3.3 0 0 0-.138-.321l-3.132-1.9a15.9 15.9 0 0 0-.918-5.082l2.267-2.871a.3.3 0 0 0 .017-.35l-2.378-3.69a.3.3 0 0 0-.325-.13l-3.558.867a16 16 0 0 0-4.25-2.942l-.432-3.634a.3.3 0 0 0-.235-.258l-4.296-.932a.3.3 0 0 0-.321.138l-1.903 3.126a16 16 0 0 0-5.09.916l-2.877-2.262a.3.3 0 0 0-.349-.017l-3.698 2.373c-.108.07-.16.2-.13.325l.869 3.552a15.9 15.9 0 0 0-2.948 4.243l-3.639.43a.3.3 0 0 0-.259.235z",
    fill: "#BDD0FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.76 91.581a4.41 4.41 0 0 1 .233-5.759 4.43 4.43 0 0 1 6.245-.207 4.38 4.38 0 0 1 1.398 3.074 4.38 4.38 0 0 1-1.19 3.16 4.428 4.428 0 0 1-6.686-.268m6.115-4.847a3.396 3.396 0 0 0-5.13-.21 3.38 3.38 0 0 0 .16 4.782 3.395 3.395 0 0 0 4.788-.16c.619-.66.943-1.52.913-2.423a3.36 3.36 0 0 0-.731-1.989",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.823 95.62a11 11 0 0 1-.837-1.206 11 11 0 0 1-.772-1.557l-.009-.022-.025-.062-.046-.122a.256.256 0 0 1 .151-.331.257.257 0 0 1 .331.15c.258.685.591 1.346.99 1.966 1.983 3.08 5.342 4.755 8.762 4.741a10.3 10.3 0 0 0 5.541-1.638q.452-.29.866-.62a10.25 10.25 0 0 0 3.65-5.877 10.25 10.25 0 0 0-1.408-7.782c-3.088-4.793-9.503-6.183-14.303-3.102q-.444.285-.854.611a10.3 10.3 0 0 0-2.823 3.49.258.258 0 0 1-.462-.228 10.8 10.8 0 0 1 3.86-4.306c5.04-3.235 11.776-1.772 15.016 3.257a10.76 10.76 0 0 1 1.478 8.17 10.77 10.77 0 0 1-4.741 6.82 10.8 10.8 0 0 1-8.184 1.476 10.8 10.8 0 0 1-6.181-3.828",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.964 64.887a.4.4 0 0 1-.014-.475c.194-.276.4-.55.61-.814a.398.398 0 0 1 .622.495q-.302.378-.582.776a.4.4 0 0 1-.636.018m1.984-2.327a.397.397 0 0 1 .033-.531 17 17 0 0 1 1.603-1.383.41.41 0 0 1 .558.075c.133.175.1.424-.075.557q-.14.106-.278.216a17 17 0 0 0-1.252 1.103.4.4 0 0 1-.59-.037m3.286-2.5a.397.397 0 0 1 .11-.59 17 17 0 0 1 1.89-.955.397.397 0 1 1 .315.73c-.616.264-1.223.57-1.803.91a.4.4 0 0 1-.512-.095m3.795-1.63a.398.398 0 0 1 .201-.63 17 17 0 0 1 2.068-.46.398.398 0 1 1 .125.784c-.664.106-1.327.253-1.972.44a.4.4 0 0 1-.422-.134m4.081-.649a.399.399 0 0 1 .298-.644 17 17 0 0 1 2.118.058.398.398 0 1 1-.072.791 17 17 0 0 0-2.019-.055.4.4 0 0 1-.325-.15m4.115.366a.399.399 0 0 1 .395-.636c.689.148 1.375.34 2.039.57a.397.397 0 1 1-.261.75 17 17 0 0 0-1.945-.543.4.4 0 0 1-.228-.14m3.902 1.352a.397.397 0 0 1 .486-.604c.632.31 1.251.663 1.839 1.048a.398.398 0 0 1-.437.665 16 16 0 0 0-1.753-1 .4.4 0 0 1-.135-.109m3.45 2.262a.397.397 0 0 1 .57-.55c.535.455 1.048.949 1.525 1.468a.4.4 0 0 1-.024.562.4.4 0 0 1-.563-.024 16 16 0 0 0-1.454-1.4.4.4 0 0 1-.054-.056m3.888 4.794-.039-.058a16 16 0 0 0-1.07-1.711.397.397 0 0 1 .093-.554.394.394 0 0 1 .555.092l.16.228c.348.505.672 1.032.962 1.566a.399.399 0 0 1-.661.437M91.71 85.154a.397.397 0 0 1 .619-.5 17 17 0 0 0 1.348 1.458.4.4 0 0 1 .012.561.4.4 0 0 1-.563.012 17 17 0 0 1-1.417-1.532m-1.192-1.648-.025-.035a17 17 0 0 1-1.009-1.82.397.397 0 0 1 .188-.53.4.4 0 0 1 .53.187c.285.595.609 1.18.963 1.737a.397.397 0 0 1-.647.46m4.125 4.454a.397.397 0 0 1 .55-.566c.53.395 1.089.762 1.661 1.089a.397.397 0 1 1-.396.69 18 18 0 0 1-1.742-1.142.4.4 0 0 1-.073-.071m-5.874-8.118a.4.4 0 0 1-.066-.122 17 17 0 0 1-.539-2.01.397.397 0 0 1 .78-.158 16 16 0 0 0 .514 1.916.397.397 0 0 1-.689.374m9.4 10.133a.396.396 0 0 1 .465-.614 16 16 0 0 0 1.875.658.397.397 0 0 1-.218.764 17 17 0 0 1-1.966-.69.4.4 0 0 1-.156-.118m3.907 1.112a.397.397 0 0 1 .373-.64c.654.103 1.32.167 1.979.191a.397.397 0 1 1-.029.794 17 17 0 0 1-2.074-.2.4.4 0 0 1-.249-.145m4.062.145a.397.397 0 0 1 .278-.643 16 16 0 0 0 1.966-.288.398.398 0 1 1 .163.778 17 17 0 0 1-2.062.302.4.4 0 0 1-.345-.148M87.959 75.847a.4.4 0 0 1-.086-.217c-.026-.339-.042-.68-.049-1.014a.398.398 0 0 1 .796-.015q.01.48.047.968a.397.397 0 0 1-.708.278",
    opacity: 0.3,
    fill: "#BDD0FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.186 72.909a.2.2 0 0 0 .092.214l2.096 1.272c.019 1.143.22 2.291.614 3.4l-1.516 1.922a.2.2 0 0 0-.011.233l1.59 2.47a.2.2 0 0 0 .218.087l2.38-.58c.847.818 1.81 1.478 2.845 1.969l.289 2.43c.01.086.073.156.157.174l2.874.623a.2.2 0 0 0 .215-.092l1.274-2.092a10.7 10.7 0 0 0 3.406-.613l1.925 1.514a.2.2 0 0 0 .234.011l2.474-1.588a.2.2 0 0 0 .087-.217l-.581-2.377c.82-.845 1.48-1.806 1.972-2.839l2.435-.288a.2.2 0 0 0 .174-.157l.624-2.87a.2.2 0 0 0-.092-.215l-2.096-1.27a10.6 10.6 0 0 0-.614-3.401l1.517-1.922a.2.2 0 0 0 .011-.233l-1.591-2.47a.2.2 0 0 0-.217-.087l-2.381.58a10.7 10.7 0 0 0-2.844-1.969l-.289-2.431a.2.2 0 0 0-.157-.173l-2.875-.623a.2.2 0 0 0-.215.092l-1.273 2.092c-1.146.018-2.296.22-3.407.613l-1.925-1.514a.2.2 0 0 0-.233-.011l-2.475 1.588a.2.2 0 0 0-.086.217l.58 2.376c-.82.846-1.48 1.807-1.972 2.84l-2.435.288a.2.2 0 0 0-.173.157z",
    fill: "#BDD0FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.76 76.078a2.98 2.98 0 0 1-.649-1.767 2.98 2.98 0 0 1 .811-2.153 3.017 3.017 0 0 1 4.254-.141 3.006 3.006 0 0 1-1.956 5.198 3 3 0 0 1-2.46-1.137m4.092-3.242a2.22 2.22 0 0 0-3.35-.134 2.2 2.2 0 0 0-.596 1.583c.02.59.269 1.137.701 1.54.432.404.995.615 1.586.596a2.21 2.21 0 0 0 1.659-3.585",
    fill: "url(#d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.32 78.886a7.6 7.6 0 0 1-1.135-1.978l-.025-.064a.397.397 0 1 1 .745-.28 6.7 6.7 0 0 0 .641 1.273l.043.066a6.64 6.64 0 0 0 4.125 2.844l.045.01a6.67 6.67 0 0 0 5.046-.91q.292-.189.561-.402a6.64 6.64 0 0 0 2.363-3.805 6.63 6.63 0 0 0-.912-5.037 6.66 6.66 0 0 0-4.212-2.919 6.67 6.67 0 0 0-5.6 1.306 6.7 6.7 0 0 0-1.827 2.259.399.399 0 0 1-.713-.353 7.47 7.47 0 0 1 2.663-2.97 7.46 7.46 0 0 1 5.646-1.018 7.44 7.44 0 0 1 4.713 3.265 7.42 7.42 0 0 1 1.02 5.636 7.43 7.43 0 0 1-3.271 4.705c-3.261 2.093-7.551 1.337-9.915-1.628",
    fill: "url(#e)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M217.556 194.443a2.855 2.855 0 0 1-2.85 2.842H60.605a2.854 2.854 0 0 1-2.85-2.842l-1.282-88.408c0-1.563 1.845-4.615 5.225-4.385l150.605-3.89a7.2 7.2 0 0 1 5.261 2.09 7.16 7.16 0 0 1 2.108 5.242z",
    fill: "url(#f)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214.742 191.716a2.7 2.7 0 0 1-2.696 2.691H64.32a2.7 2.7 0 0 1-2.696-2.691l-1.21-80.257c.143-4.83 4.384-6.566 6.955-6.463l144.346-3.866a5.05 5.05 0 0 1 3.696 1.469 5.02 5.02 0 0 1 1.477 3.687z",
    fill: "#7D97F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.922 176.073c.142-5.624.089-55.424-.261-59.725s6.924-5.108 18.094-5.592c11.169-.484 105.411-2.4 107.837-2.581 5.455-.407 6.584 7.099 6.038 23.395-.41 12.242-1.089 32.41-1.402 41.685-.093 2.761-2.545 4.952-5.545 4.96-22.679.057-109.598.287-115.385.445-6.659.183-9.433-.357-9.376-2.587",
    fill: "url(#g)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.166 204.624H52.267a3.9 3.9 0 0 1-3.89-3.884 3.9 3.9 0 0 1 3.89-3.884h173.899c2.14 0 3.89 1.748 3.89 3.884a3.9 3.9 0 0 1-3.89 3.884",
    fill: "url(#h)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m119.094 182 .085.432c.077.396 1.165.373 1.943.373l81.409.325c.836 0 1.009-.66 1.009-.66 0-.425-.163-.886-.994-.89l-81.759-.389c-.902-.004-1.783.349-1.693.809",
    fill: "#BDD0FB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M145.81 182.499c-.14-.402-.312-.81-.477-1.22l-73.877-.266c-1.32-.005-2.358.393-2.226.852l.124.432c.113.396 1.066.698 2.203.698h74.459a7 7 0 0 1-.206-.496",
    fill: "url(#i)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M147.554 182.538a1.403 1.403 0 0 1-2.808 0c0-.774.629-1.401 1.404-1.401s1.404.627 1.404 1.401",
    fill: "url(#j)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.969 222.721h-85.856v-17.155l85.856.001c-1.838 0-1.838 17.154 0 17.154",
    fill: "#91B3FA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M142.113 218.428v-7.85c0-2.768 1.697-5.011 3.79-5.011h84.464a.22.22 0 0 0 .22-.22v-3.44a.22.22 0 0 0-.22-.219h-89.982c-2.048 0-5.299 3.214-5.299 7.179v10.964c0 3.739 3.156 6.769 5.087 6.769h90.194a.22.22 0 0 0 .22-.219v-3.441a.22.22 0 0 0-.22-.219h-85.008c-1.793 0-3.246-1.922-3.246-4.293",
    fill: "url(#k)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "m226.157 221.318-76.763.001c-3.351 0-6.068-2.318-6.068-5.176v-3.542c0-3.166 3.009-5.733 6.721-5.733h76.11c-1.812 0-1.812 14.45 0 14.45",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M224.996 209.306h-80.501a.22.22 0 0 1 0-.439h80.501a.22.22 0 1 1 0 .439",
    fill: "url(#l)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M224.996 211.852h-80.501a.22.22 0 0 1 0-.439h80.501a.22.22 0 1 1 0 .439",
    fill: "url(#m)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.996 214.399h-80.501a.22.22 0 1 1 0-.439h80.501a.22.22 0 1 1 0 .439",
    fill: "url(#n)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M224.996 216.944h-80.501a.22.22 0 0 1-.22-.219.22.22 0 0 1 .22-.219h80.501a.22.22 0 1 1 0 .438",
    fill: "url(#o)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M224.996 219.491h-80.501a.22.22 0 0 1-.22-.219.22.22 0 0 1 .22-.219h80.501a.22.22 0 1 1 0 .438",
    fill: "url(#p)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M161.619 201.804h67.951a.7.7 0 0 0 .699-.698v-15.315a.7.7 0 0 0-.699-.698h-67.951a.7.7 0 0 0-.699.698v15.315c0 .386.313.698.699.698",
    fill: "url(#q)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M214.285 199.884h8.147v-12.87h-8.147zm-4.256 0h3.057v-12.87h-3.057z",
    fill: "#91B3FA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M168.319 202.104c.029-.011 15.472-27.008 17.558-29.549a1.62 1.62 0 0 1 1.444-.58l4.311.513 5.063 10.936-8.436-4.905c.835 5.764-10.002 14.329-13.719 17.454a.85.85 0 0 0-.067 1.241l1.484 1.551c-2.436 2.465-5.247 4.048-8.42 4.78z",
    fill: "url(#r)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M175.098 197.928s.947.305 1.268 1.147c.153.403-.012.859-.363 1.11-1.559 1.116-6.703 4.716-9.077 5.421a.268.268 0 0 1-.336-.315c.122-.551.516-1.65 1.786-3.259l-.114.23c-.144.291.173.594.456.434 1.588-.895 4.822-2.853 6.38-4.768",
    fill: "url(#s)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M174.333 208.73c.026-.017 2.343-5.589 2.369-5.606 2.124-12.912 7.307-23.97 8.836-26.88a1.62 1.62 0 0 1 1.296-.859l4.325-.368 7.176 9.686-9.255-3.099c1.985 5.476-6.891 16.053-9.897 19.865a.85.85 0 0 0 .185 1.229l1.768 1.219c-1.886 2.906-4.318 5.024-7.277 6.382z",
    fill: "url(#t)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M180.126 203.271s.99.107 1.474.867c.232.364.163.844-.13 1.161-1.301 1.407-5.608 5.972-7.79 7.142a.268.268 0 0 1-.393-.241c.008-.564.171-1.72 1.088-3.552l-.065.248c-.082.314.29.547.535.333 1.373-1.197 4.143-3.768 5.281-5.958",
    fill: "url(#u)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M211.405 172.977s3.913 5.809 4.234 8.46c.321 2.65-1.082 3.566-5.177 3.904-12.187 1.006-18.194-2.64-18.194-2.64-.834-5.307-1.427-6.657-8.389-9.542 0 0 8.806.698 10.578.012 1.773-.687 16.948-.194 16.948-.194",
    fill: "url(#v)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M195.805 140.428s2.725-3.219 5.622.73c.525.716 2.54.125 3.279 1.622.381.773 1.205 1.213 2.054 1.056 2.114-.389 5.57-.422 7.276 2.885 1.302 2.525.296 4.002-1.005 4.845-.956.618-1.298 1.874-.72 2.854.555.94.659 2.213-.773 3.745-3.208 3.434-9.56-2.178-9.56-2.178l-5.044-11.898z",
    fill: "url(#w)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M200.825 172.208s-4.556-4.331-6.799-7.2a6.08 6.08 0 0 1-1.032-5.478c1.024-3.444 2.843-7.011 3.009-7.566.255-.851 5.363-.815 5.363-.815s10.053 6.513 14.003 17.546l-4.436 1.379s-2.625-4.396-5.218-7.191c0 0 4.488 5.918 4.646 8.341z",
    fill: "url(#x)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m192.145 173.917 3.423-3.719 3.954 1.063s4.609.713 7.248 0l2.638-.713 5.962-1.853.936 2.642a1.59 1.59 0 0 1-.582 1.828c-.516.365-1.121.767-1.506.936-.785.343-18.086.108-18.086.108z",
    fill: "url(#y)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m197.856 145.017 3.434 6.374c-.227 1.392-3.737 1.431-4.28.6a.8.8 0 0 1-.107-.281l-2.054-4.259c-.089-.415 1.052-1.815 1.427-2.014l1.365-.725c.525-.28-1.667-.302.215.305",
    fill: "url(#z)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M190.905 143.521s-.387 2.153 1.308 4.891 3.384 2.615 4.242 1.638c.858-.976 1.885-2.602 1.418-5.333s-6.382-3.942-6.968-1.196",
    fill: "url(#A)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M195.821 145.013s-2.745-3.6-4.853-.462l.035 1.085s-2.741-.128-2.443-2.65c.297-2.522 2.535-4.245 5.637-3.384s4.915 1.843 5.265 3.994c.35 2.15-1.408 1.798-1.408 1.798s-.672-1.483-1.483-1.585c-.812-.101-.518 1.073-.518 1.073z",
    fill: "url(#B)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M196.451 144.917s-1.422-1.842-.128-2.224 1.246 1.805 1.162 2.619z",
    fill: "url(#C)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m203.475 175.388-.036.001-15.747-.017a.704.704 0 1 1 .002-1.407l15.747.017a.704.704 0 0 1 .034 1.406",
    fill: "url(#D)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M173.537 161.115h13.114a2.5 2.5 0 0 1 2.26 1.431l6.063 12.834h-16.297a1.52 1.52 0 0 1-1.413-.959l-4.701-11.876a1.046 1.046 0 0 1 .974-1.43",
    fill: "url(#E)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M182.775 167.695c.285.881.075 1.737-.469 1.912s-1.213-.399-1.498-1.28-.074-1.737.469-1.912 1.214.399 1.498 1.28",
    fill: "url(#F)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m182.824 86.872-2.717 9.773a4.74 4.74 0 0 0 .618 3.894c1.916 2.88 6.6 8.081 16.53 10.735 10.085 2.694 15.795-.078 18.252-1.905a5.05 5.05 0 0 0 1.842-2.659l2.973-10.35z",
    fill: "url(#G)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m204.323 74.293-28.247 7.9c-1.454.406-1.867 2.268-.719 3.248 5.6 4.78 18.325 15.916 23.145 22.383a1.886 1.886 0 0 0 2.234.613l28.581-11.81a1.884 1.884 0 0 0 .525-3.16c-5.545-4.86-19.656-17.028-24.243-19.082a1.88 1.88 0 0 0-1.276-.092",
    fill: "url(#H)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M203.712 88.86s15.06 9.483 16.207 11.65-1.162 12.015-1.162 12.015c2.371 8.335 2.722 17.387-1.283 22.122 0 0-4.937-10.961-2.732-15.581s3.056-6.514 3.056-6.514 1.93-10.499 1.319-12c0 0-16.683-11.091-15.405-11.692",
    fill: "url(#I)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m179.878 84.808 14.456 14.236 3.615 3.559.903.889.451.443a2.71 2.71 0 0 0 2.752.608l9.628-3.22a.145.145 0 0 1 .093.275l-9.603 3.292a3.09 3.09 0 0 1-3.141-.673l-.457-.442-.91-.883-3.641-3.532-14.564-14.126a.3.3 0 0 1 .417-.428zm37.776 32.782-.029.03-.033.04-.068.08-.13.174c-.086.118-.161.248-.242.371l-.215.394c-.067.134-.125.273-.188.41-.067.135-.116.278-.168.421-.05.143-.107.283-.153.428l-.123.439c-.04.147-.088.292-.112.443l-.09.449c-.029.15-.065.299-.079.451-.036.305-.077.608-.109.913l-.044.922c-.003.076-.009.153-.01.23l.006.231.01.462c-.005.618.08 1.231.129 1.848.01.154.036.307.061.46l.072.458c.049.306.093.613.148.918.137.604.261 1.212.408 1.815l.507 1.794.001.005a.103.103 0 0 1-.072.128.1.1 0 0 1-.127-.069l-.557-1.791c-.164-.604-.306-1.214-.46-1.821-.063-.307-.115-.616-.174-.924l-.085-.463c-.029-.154-.059-.309-.073-.465-.067-.624-.169-1.246-.18-1.877l-.024-.472-.011-.236c-.002-.079.002-.158.003-.237l.021-.947c.025-.315.059-.63.088-.946.01-.158.044-.314.07-.47l.081-.47c.022-.158.068-.311.105-.466l.118-.464c.045-.154.1-.305.15-.457s.099-.305.166-.452c.064-.148.122-.298.191-.444l.221-.433c.087-.14.165-.282.259-.419l.144-.204.081-.101.041-.05.05-.056a.299.299 0 1 1 .441.403z",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m218.115 121.47-.001.586.005.662.017 1.325.046 2.652.107 5.306a.163.163 0 0 1-.159.166.163.163 0 0 1-.166-.155l-.243-5.302-.114-2.652-.052-1.327-.022-.665-.008-.335-.004-.169c.001-.073.006-.158.013-.236a.29.29 0 0 1 .581.026z",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M117.33 126.547H56.605a4.77 4.77 0 0 1-4.75-4.316l-3.828-40.535a4.766 4.766 0 0 1 4.66-5.21l64.552-1.226a4.767 4.767 0 0 1 4.862 4.762v41.762a4.767 4.767 0 0 1-4.771 4.763",
    fill: "#91B3FA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m51.91 85.309 2.714 35.051a2.95 2.95 0 0 0 2.911 2.719l58.283.609a2.95 2.95 0 0 0 2.981-2.946V83.007a2.95 2.95 0 0 0-3.051-2.945l-60.997 2.076a2.95 2.95 0 0 0-2.842 3.171",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.512 117.308h52.448a2.773 2.773 0 0 0 2.775-2.801l-.265-24.435-4.46 5.633-3.611.46s-3.235.115-4.103.23c-.868.116-4.868 1.037-4.868 1.037l-3.856 1.956-.907 2.487-2.651 1.517-2.875 1.688h-5.846l-7.19-3.205h-2.44l-4.431 2.577-4.15 4.808z",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m59.091 87.322 32.867-.982c.337-.01.615.26.615.596v.529a.597.597 0 0 1-.59.596l-32.865.453a.597.597 0 0 1-.027-1.192",
    fill: "url(#J)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M58.512 90.669v.225c0 .33.267.597.597.597h32.867c.33 0 .597-.268.597-.597v-.225a.597.597 0 0 0-.597-.597H59.109a.597.597 0 0 0-.597.597",
    fill: "url(#K)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M58.693 117.308q-.22 0-.436-.089a1.114 1.114 0 0 1-.592-1.462c3.788-8.912 8.045-13.764 13.014-14.832 3.423-.736 6.07.621 8.406 1.819 2.486 1.274 4.633 2.375 7.576 1.266 2.22-.837 3.436-2.377 4.724-4.007 1.606-2.033 3.266-4.134 6.782-4.73 1.758-.297 3.133-.065 4.346.139 1.468.247 2.627.442 4.233-.332 1.887-.91 3.538-2.738 4.908-5.432.28-.55.952-.769 1.502-.49s.769.95.49 1.499c-1.596 3.14-3.591 5.303-5.929 6.43-2.247 1.085-3.939.8-5.576.524-1.139-.192-2.214-.374-3.6-.139-2.668.452-3.935 2.055-5.402 3.912-1.354 1.714-2.889 3.656-5.689 4.712-3.87 1.459-6.8-.043-9.385-1.368-2.197-1.127-4.273-2.192-6.915-1.623-4.148.892-7.993 5.442-11.429 13.523-.18.424-.593.68-1.028.68",
    fill: "url(#L)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "M",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 89,
    width: 87,
    height: 90
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M165.207 89.138H79.463v89.474h85.744z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#M)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.628 116.352c-.126.397 1.325 1.002 2.178-.623.03-.779.505-4.117.039-4.752-2.484-3.38-7.3-7.618-7.3-7.618-.813.802-.143 1.59-.143 1.59l2.336 2.429c-.488.881-1.084 1.625-1.364 2.692a3.26 3.26 0 0 0 .327 2.405c.41.737.97 1.696 1.498 2.446 1.001 1.42 2.428 1.431 2.428 1.431",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.76 108.954 2.129 1.802.668 1.793-1.898 2.102s-.638-3.559-1.113-4.329c-.474-.77-.228-1.143.214-1.368",
    fill: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.962 178.891c.187.949 1.002 47.376-3.969 68.182a.705.705 0 0 0 .414.821c.763.311 2.258.762 4.049.822a1.22 1.22 0 0 0 1.209-.873c1.421-4.828 8.23-29.013 9.118-52.117.993-25.817 0-.879 0-.879l-.582-15.958z",
    fill: "url(#P)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.638 180.315c4.066 24.495-.882 60.542-2.551 67.597a1.1 1.1 0 0 1-.89.836c-.744.123-1.971.224-3.18-.127a1.01 1.01 0 0 1-.726-.929c-.224-5.703.179-40.72-3.609-54.559a3.14 3.14 0 0 0-1.215-1.734l-7.353-5.219-.563-8.435z",
    fill: "url(#Q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.729 133.901c12.185-.201 25.628 3.193 25.628 3.193 3.632 21.156.636 45.558.636 45.558-9.433 2.47-20.074-1.51-20.074-1.51-1.568-8.843-8.882-33.729-8.882-33.729-5.954-.737-10.858-2.452-14.896-4.719 3.08-3.565 4.532-8.101 5.163-10.782 4.308 1.337 8.667 2.051 12.425 1.989",
    fill: "url(#R)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.74 115.984c1.197-1.443 2.712-.76 2.712-.76 1.793 7.561 11.195 13.692 20.853 16.688-.631 2.682-2.083 7.218-5.163 10.782-16.03-8.997-18.402-26.71-18.402-26.71",
    fill: "url(#S)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.686 148.873 4.673-11.778s11.381 7.719 13.252 17.507c-2.15.158-6.063.716-9.893 2.647-.842-4.621-8.032-8.376-8.032-8.376",
    fill: "url(#T)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.073 124.026 3.877 11.193a.405.405 0 0 1-.184.486c-1.057.583-4.865 2.269-9.453-.635a1.9 1.9 0 0 1-.876-1.357l-1.255-9.687z",
    fill: "url(#U)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.637 113.661s-4.257 8-3.712 11.232c.546 3.231 5.822 2.999 10.429.375l3.22-8.639z",
    fill: "url(#V)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.15 121.026a.33.33 0 0 1-.144-.483c.341-.52.981-1.581 1.185-2.51 0 0 .765-.489-1.948-1.138s-6.759-1.654-7.61-3.96c-.829-2.248 1.35-7.9 4.825-3.396a.33.33 0 0 0 .524.003c.569-.74 2.068-2.277 4.147-1.345 1.946.872 2.166 2.295 2.139 3.013a.33.33 0 0 0 .389.336c.984-.188 3.345-.349 4.448 2.07.907 1.992.317 3.119-.22 3.671a.328.328 0 0 0 .141.545c.647.198 1.482.745 1.398 2.258-.115 2.091-2.457 1.907-3.124 1.812a.33.33 0 0 0-.293.103c-.572.632-3.148 3.314-5.936 3.637a.333.333 0 0 1-.349-.44l1.206-3.501a.33.33 0 0 0-.179-.41z",
    fill: "url(#W)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.665 121.523s3.031-2.076 3.253-.328c.221 1.749-2.73 2.533-4.191 1.881z",
    fill: "url(#X)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.717 157.25s3.978 17.914.374 27.986c4.418 2.045 3.602 1.659 3.602 1.659s8.739-25.489 5.917-32.293c-5.562-.589-8.321.903-9.893 2.648",
    fill: "url(#Y)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 244.628,
    y1: 259.021,
    x2: 118.334,
    y2: 124.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 131.803,
    y1: 88.836,
    x2: 140.638,
    y2: 88.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 126.117,
    y1: 88.852,
    x2: 147.18,
    y2: 88.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 102.109,
    y1: 74.212,
    x2: 108.128,
    y2: 74.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 98.135,
    y1: 74.218,
    x2: 112.68,
    y2: 74.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 123.58,
    y1: 190.489,
    x2: 159.864,
    y2: 81.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 71.648,
    y1: 143.426,
    x2: 203.754,
    y2: 143.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 132.423,
    y1: 237.822,
    x2: 146.093,
    y2: 162.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 69.219,
    y1: 182.004,
    x2: 146.016,
    y2: 182.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 146.818,
    y1: 180.007,
    x2: 139.068,
    y2: 209.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 161.166,
    y1: 291.224,
    x2: 194.057,
    y2: 178.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 144.275,
    y1: 209.086,
    x2: 225.216,
    y2: 209.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 144.275,
    y1: 211.632,
    x2: 225.216,
    y2: 211.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 144.275,
    y1: 214.179,
    x2: 225.216,
    y2: 214.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 144.275,
    y1: 216.725,
    x2: 225.216,
    y2: 216.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 144.275,
    y1: 219.272,
    x2: 225.216,
    y2: 219.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 234.331,
    y1: 117.827,
    x2: 214.11,
    y2: 157.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 164.618,
    y1: 179.488,
    x2: 188.944,
    y2: 193.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 161.776,
    y1: 174.467,
    x2: 184.112,
    y2: 238.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 166.972,
    y1: 182.947,
    x2: 83.751,
    y2: 130.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 165.252,
    y1: 173.256,
    x2: 187.588,
    y2: 237.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 631.848,
    y1: 920.546,
    x2: 609.173,
    y2: 881.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 191.632,
    y1: 132.35,
    x2: 202.197,
    y2: 144.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 241.261,
    y1: 120.026,
    x2: 211.883,
    y2: 153.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 207.261,
    y1: 171.491,
    x2: 231.513,
    y2: 171.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 197.39,
    y1: 159.92,
    x2: 197.948,
    y2: 151.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 198.214,
    y1: 152.541,
    x2: 187.689,
    y2: 132.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 185.029,
    y1: 141.106,
    x2: 199.804,
    y2: 144.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 200.63,
    y1: 151.281,
    x2: 190.105,
    y2: 131.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 206.147,
    y1: 171.212,
    x2: 193.651,
    y2: 175.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 173.218,
    y1: 169.173,
    x2: 287.324,
    y2: 159.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 183.533,
    y1: 165.394,
    x2: 179.458,
    y2: 171.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 225.357,
    y1: 49.48,
    x2: 203.45,
    y2: 90.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 200.698,
    y1: 103.186,
    x2: 205.514,
    y2: 68.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 244.663,
    y1: 57.282,
    x2: 221.436,
    y2: 94.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 75.542,
    y1: 15.158,
    x2: 75.542,
    y2: 51.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 75.543,
    y1: 15.159,
    x2: 75.543,
    y2: 51.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 80.943,
    y1: 100.301,
    x2: 154.432,
    y2: 145.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 97.326,
    y1: 122.435,
    x2: 84.399,
    y2: 104.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 97.186,
    y1: 101.51,
    x2: 71.553,
    y2: 135.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 110.342,
    y1: 181.055,
    x2: 154.432,
    y2: 240.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 118.218,
    y1: 175.253,
    x2: 162.307,
    y2: 235.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: -1233.28,
    y1: 457.426,
    x2: -1158.5,
    y2: 440.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 92.374,
    y1: 101.469,
    x2: 100.488,
    y2: 124.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: -1234.46,
    y1: 452.051,
    x2: -1159.68,
    y2: 435.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 159.901,
    y1: 171.018,
    x2: 129.664,
    y2: 122.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 126.377,
    y1: 122.886,
    x2: 139.329,
    y2: 114.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 146.203,
    y1: 106.672,
    x2: 129.477,
    y2: 119.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 129.781,
    y1: 125.83,
    x2: 141.434,
    y2: 118.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 150.843,
    y1: 216.92,
    x2: 160.397,
    y2: 148.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPastClasses);
export default __webpack_public_path__ + "static/media/noPastClasses.089a7a45d12c54fd3b7d025bb14149f9.svg";
export { ForwardRef as ReactComponent };